const MS_PER_DAY = 86_400_000;

export function formatTimeAgo(isoLike: string | null | undefined): string {
  if (!isoLike) return "";
  const ts = Date.parse(isoLike);
  if (Number.isNaN(ts)) return "";
  const diffMs = Date.now() - ts;
  if (diffMs < 0) return "just now";
  const days = Math.floor(diffMs / MS_PER_DAY);
  if (days < 1) {
    const hours = Math.floor(diffMs / 3_600_000);
    if (hours < 1) return "just now";
    return `${hours}h`;
  }
  if (days < 7) return `${days}d`;
  const weeks = Math.floor(days / 7);
  if (weeks < 5) return `${weeks}w`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months}mo`;
  const years = Math.floor(days / 365);
  return `${years}y`;
}

export function formatSavedFrom(
  isoLike: string | null | undefined,
  source: "chat" | "manual" | "note" | null,
): string {
  const ago = formatTimeAgo(isoLike);
  const lead =
    source === "chat"
      ? "Saved from chat"
      : source === "note"
      ? "Personal note"
      : source === "manual"
      ? "Saved manually"
      : "Saved";
  if (!ago) return lead;
  return `${lead} · ${ago} ago`;
}

export function deriveSourceFromUrl(
  url: string | null | undefined,
  fallback: string,
): string {
  if (!url) return fallback;
  try {
    return new URL(url).host.replace(/^www\./, "");
  } catch {
    return fallback;
  }
}

// Friendly label for each content_type. Backend allows
// video|article|course|podcast|note|link|quote.
export const LIBRARY_TYPE_LABEL: Record<string, string> = {
  article: "Article",
  video: "Video",
  course: "Course",
  podcast: "Podcast",
  note: "Note",
  link: "Link",
  quote: "Quote",
};

export const LIBRARY_TYPE_FALLBACK = "article";

export function libraryTypeKey(type: string | null | undefined): string {
  if (!type) return LIBRARY_TYPE_FALLBACK;
  return LIBRARY_TYPE_LABEL[type] ? type : LIBRARY_TYPE_FALLBACK;
}

export const LIBRARY_TYPE_KEYS: ReadonlyArray<string> = [
  "article",
  "video",
  "course",
  "podcast",
  "note",
  "link",
  "quote",
];

export type LibraryViewMode = "grid" | "list";
export type LibrarySortMode = "recent" | "alpha" | "area";

// Backend doesn't (yet) record origin "chat" vs "manual". For now
// derive a best-effort label so cards aren't all literally "Saved":
//   note type      → "Personal note"
//   has url        → "Saved manually" (will tighten when origin lands)
//   else           → null (no prefix)
export function libraryItemSource(
  contentType: string | null | undefined,
  hasUrl: boolean,
): "chat" | "manual" | "note" | null {
  if (contentType === "note") return "note";
  if (hasUrl) return "manual";
  return null;
}
